'use client';

import { HOME_ROUTE } from '@/constants/ui.constants';
import { useSession } from 'next-auth/react';
import { redirect, usePathname } from 'next/navigation';

export default function AppUserRedirect({ children }: { children: React.ReactNode }) {
	const { data: session } = useSession();
	const pathname = usePathname();
	if (!!session?.role && ['user', 'admin'].includes(session.role) && pathname.startsWith('/auth'))
		redirect(HOME_ROUTE);

	return <>{children}</>;
}
